import { FilePath } from 'app/model/dataset/file-path';
import { AzureDataLakeStoreLinkedService } from 'app/model/linkedservice/azure-data-lake-store.linkedservice';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Location } from 'app/model/dataset/location/location';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ILocationPath } from 'shell-models-lib';

@Metamodel.model({
    name: 'AzureDataLakeStoreLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureDataLakeStoreLinkedService)
    }
})
export class AzureDataLakeLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;
    public static readonly CONTAINER: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', AzureDataLakeLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', AzureDataLakeLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: AzureDataLakeLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: AzureDataLakeLocation.FILE_NAME.templateValue(this) || this.fileName
        };
    }


    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && AzureDataLakeLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(AzureDataLakeLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(AzureDataLakeLocation.FILE_NAME.templateValue(this));
    }
}
